import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import HeadLines from "../../../CommonComponents/HeadLines";
import { useClickOutside } from "../../../CustomHooks/useClickOutside";

const AccountSwitcher = ({ profileUserOption, selectOptionFun }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState({});

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const ref = useRef();
  const flag = useClickOutside(ref);

  useEffect(() => {
    if (flag) {
      setIsOpen(false);
    }
  }, [flag]);

  useEffect(() => {
    if (profileUserOption?.length > 0) {
      handleProfileSelection(profileUserOption);
    }
    if (Object.keys(selectedOption).length == 0) {
      handleProfileSelection(profileUserOption);
    }
  }, [profileUserOption, profileUserOption?.length]);

  const handleProfileSelection = (profileUserOption) => {
    profileUserOption?.forEach((item) => {
      if (item?.selected === true) {
        setSelectedOption(item);
      }
    });
  };
  return (
    <div className="dropdown-container" ref={ref}>
      <div className="dropdown-label-container">
        <HeadLines className="dropdown-label" text="Switch Account" />
      </div>
      <div className="dropdown-header textWrap h-100 d-flex gap8" onClick={toggleDropdown}>
        <HeadLines
          className={`textWrap textColorWhite`}
          text={`${selectedOption?.name ? selectedOption?.name : ""} ${
            selectedOption?.gstState ? ` (${selectedOption?.gstState})` : ""
          }`}
        />
        <div className={`dropdown-arrow ${isOpen ? "open" : ""}`} />
      </div>
      {isOpen && (
        <ul className="dropdown-options">
          {profileUserOption.map((option, index) => (
            <li
              key={index}
              className={`dropdown-option ${
                selectedOption.id === option.id ? "selected" : ""
              }`}
              value={option.id}
              onClick={() => {
                if (selectedOption.id !== option.id) {
                  setSelectedOption(option);
                }
                setIsOpen(false);
                selectOptionFun(option);
              }}
            >
              {option.name}
              {option?.gstState ? ` (${option?.gstState})` : ""}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AccountSwitcher;
